import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import CustomButton from "../component/button";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { toastMsg } from "../component/toast";

function DetailedPersonality({
  isDetailedPersonality,
  setIsDetailedPersonality,
  code,
  getList,
  setCountMatch,
}) {
  const [match, setMatch] = useState(true);

  const [mails, setMails] = useState([]);

  const [nonMatchList, setNonMatchList] = useState([])

  const [currentSelected, setCurrentSelected] = useState("Match");

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setCurrentSelected("Match");
    getMatchList();
    getManualMatch()
  }, [isDetailedPersonality]);

  const getManualMatch = () => {

    simpleGetCallWithErrorResponse(ApiConfig?.GET_MANUAL_MATCH + code).then((res) => {

      setNonMatchList(res?.json)


    })

  }

  const getMatchList = () => {
    simpleGetCallWithErrorResponse(
      ApiConfig.GET_EXCEL_QUIZ_EMAIL_MATCH + code
    ).then((res) => {

      // setCountMatch(res?.json?.matches?.length);

      setMails(res?.json?.matches);
    });
  };

  useEffect(() => {
    setCountMatch(mails?.length + nonMatchList?.excelSheetUsers?.length)
  }, [nonMatchList, mails])



  const handleCurrent = (type) => {
    setCurrentSelected(type);
  };

  const updateIsMatch = (userId, excelEmail, value) => {
    setMails((prev) =>
      prev.map((user) =>
        user.userId === userId
          ? {
            ...user,
            excelMatches: user.excelMatches.map((match) =>
              match.email === excelEmail
                ? { ...match, isMatch: value }
                : match
            ),
          }
          : user
      )
    );
  };

  const updateQuizScore = () => {
    let current = currentSelected?.toLowerCase() + "Match";

    if (!mails.length) {
      toastMsg("error", "No Record Found ");
      return;
    }

    setIsLoading(true);

    let payload = {
      code,
      matchTab: current,
      userMatches: mails,
    };
    PostCallWithErrorResponse(ApiConfig?.UPDATE_QUIZ_SCORE_MAIL, payload).then(
      (res) => {
        if (res?.json?.succeded) {
          getList(code);
          toastMsg("success", res?.json?.response?.statusMessage);
          setIsDetailedPersonality(false);
        } else {
          toastMsg("error", res?.json?.response?.statusMessage);
        }

        setIsLoading(false);
      }
    );
  };

  const handleSingleSelect = (id, index) => {


    let removeId = nonMatchList?.excelSheetUsers?.map((i) => {

      if (i?.userId === id) {
        return {
          ...i,
          userId: ''
        }
      }

      return i

    })

    removeId[index].userId = id

    setNonMatchList(prev => ({
      ...prev,
      excelSheetUsers: removeId
    }))




  }

  const updateSingleQuizScore = (index) => {



    if (!nonMatchList?.excelSheetUsers[index]?.userId) {
      toastMsg('error', 'Please Select System User')
      return
    }

    let user = nonMatchList?.excelSheetUsers[index]

    PostCallWithErrorResponse(ApiConfig.UPDATE_SINGLE_QUIZ_SCORE + `userId=${user?.userId}&code=${code}&quizScore=${user?.quizScore}&excelEmail=${user?.email}`).then((res) => {

      if (res?.json?.succeded) {
        setNonMatchList(prev => ({
          ...prev,
          excelSheetUsers: nonMatchList?.excelSheetUsers?.filter((_, indx) => index != indx),
          usersNotCompleted: nonMatchList?.usersNotCompleted?.filter((i) => i?.userId != user?.userId)
        }))

        getMatchList()

        getList(code)

        toastMsg('success', res?.json?.response?.statusMessage)

      }

    })

  }

  return (
    <Modal
      show={isDetailedPersonality}
      centered
      onHide={() => setIsDetailedPersonality(false)}
      dialogClassName="custom-large-modal"

    >
      <Modal.Header closeButton>
        <h6 className="mb-0 mt-1 ">Quiz Emails Match Utility</h6>
      </Modal.Header>

      <Modal.Body style={{

      }}>
        <div>
          <p className="interRegular">
            Few Responses on the quiz could not find a matching email.{" "}
          </p>
          <p className="interRegular">
            Please Confirm the matching below and click on update score to
            update there respective score
          </p>
        </div>


        <div className={`d-flex gap-2 mb-2 mt-3`}>
          <span
            className={`${currentSelected == "Match" ? "fw-bold borderChip" : ""
              } pt-1 pb-1 ps-3 pe-3 interRegular`}
            onClick={() => handleCurrent("Match")}
          >
            Match
          </span>
          <span
            className={`${currentSelected == "Non Match" ? "fw-bold borderChip" : ""
              } pt-1 pb-1 ps-3 pe-3 interRegular`}
            onClick={() => handleCurrent("Non Match")}
          >
            {" "}
            Non Match
          </span>

          {/* <span className={`${currentSelected == 'Poor' ? 'fw-bold borderChip' : ''} pt-1 pb-1 ps-3 pe-3 interRegular`}
            onClick={() => handleCurrent('Poor')}
          >Poor</span> */}
        </div>
        <div
          style={{
            minHeight: "400px",
            maxHeight: "600px",
            overflowY: "auto",
            textAlign: "center",
            overflowX: "hidden",
          }}
        >
          {
            currentSelected === 'Match' ? <Table bordered hover responsive className="custom-table-border1">
              <thead>
                <tr>
                  <th style={{ fontWeight: "500", textAlign: 'left', minWidth: '140px' }} className="interRegular pb-0"><h6>Name</h6> </th>
                  <th style={{ fontWeight: "500", textAlign: 'left', minWidth: '120px' }} className="interRegular pb-0"><h6> Email</h6></th>
                  <th style={{ fontWeight: "500", textAlign: 'left', width: '90px' }} className="interRegular pb-0"> <th
                    style={{
                      fontWeight: "500",
                      textAlign: "left",
                      width: "90px",
                    }}
                    className="interRegular pb-0"
                  >
                    <h6>Match %</h6>
                  </th></th>
                  <th style={{ fontWeight: "500", width: '90px' }} className="interRegular pb-0"><h6>Match</h6></th>
                </tr>
              </thead>
              <tbody>
                {
                  mails?.map((i, index) => {
                    return <tr>
                      <td style={{ textAlign: "left", minWidth: '140px' }}>
                        <div style={{ fontSize: "14px" }} className="interRegular">
                          <span
                            style={{
                              color: "#444ce7",
                            }}
                          >
                            {i?.name}
                          </span> <br />
                          {
                            i?.excelMatches?.map((i) => {
                              return <span
                                style={{
                                  color: "#009746",
                                  // marginLeft: "10px",
                                  paddingTop: "10px",
                                }}
                              >
                                {i?.nameInSheet}
                              </span>
                            })
                          }

                        </div>
                      </td>
                      <td style={{ textAlign: 'left', minWidth: '120px' }}>  <div style={{ fontSize: "14px" }} className="interRegular">
                        <span
                          style={{
                            color: "#444ce7",
                          }}
                        >
                          {" "}
                          {i?.email}
                        </span>
                        <br />
                        {
                          i?.excelMatches?.map((i) => {
                            return <span
                              style={{
                                color: "#009746",
                              }}
                            >
                              {i?.email}
                            </span>
                          })
                        }

                      </div></td>
                      <td style={{ textAlign: "left", maxWidth: '60px' }}>
                        <div className="interRegular">
                          {
                            i?.excelMatches?.map((email) => {
                              return <div style={{ fontSize: "14px" }}>{email?.percentage}%</div>
                            })
                          }

                        </div>
                      </td>
                      <td className="text-center">
                        {
                          i?.excelMatches?.map((email) => {
                            return <input type="checkbox"
                              onChange={(e) => updateIsMatch(i?.userId, email?.email, e.target.checked)}
                              checked={email?.isMatch}
                            />
                          })
                        }
                        {/* <Form.Check
                      type="switch"
                      // id="match-switch"
                      checked={match}
                      onChange={() => setMatch(!match)}
                      // label={match ? "Yes" : "No"}
                      style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}
                    /> */}
                      </td>
                    </tr>
                  })
                }


              </tbody>
            </Table> :
              <Table bordered hover responsive className="custom-table-border1">
                <thead>
                  <tr>
                    <th style={{ fontWeight: 500, textAlign: "left", minWidth: "140px" }}>
                      <h6>System Name</h6>
                    </th>

                    <th style={{ fontWeight: 500, textAlign: "left", minWidth: "140px" }}>
                      <h6>System Email</h6>
                    </th>

                    <th style={{ fontWeight: 500, textAlign: "left", minWidth: "160px" }}>
                      <h6>Quiz Name</h6>
                    </th>

                    <th style={{ fontWeight: 500, textAlign: "left", minWidth: "120px" }}>
                      <h6>Quiz Email</h6>
                    </th>



                    <th style={{ fontWeight: 500, textAlign: "center" }}>
                      <h6>Match</h6>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {
                    nonMatchList?.excelSheetUsers?.map((i, index) => {
                      return <tr>
                        {/* First Cell */}
                        <td style={{ textAlign: "left", minWidth: "140px" }}>
                          <div className="canLisIconBox d-flex align-items-center"
                            style={{ width: "160px", height: "40px", }}>
                            <select
                              className="border-0 search-input"
                              style={{
                                width: "210%",
                                height: "130%",
                                outline: "none",
                                background: "transparent",
                                cursor: "pointer",
                              }}
                              value={i?.userId}
                              onChange={(e) => handleSingleSelect(e.target.value, index)}
                            >
                              <option value={''}>Select Name</option>
                              {
                                nonMatchList?.usersNotCompleted?.map((list) => {

                                  return <option value={list?.userId}>{list?.name}</option>

                                })
                              }
                            </select>
                          </div>
                        </td>

                        {/* Second Cell */}
                        <td style={{ textAlign: "left", minWidth: "140px" }}>
                          <div className="canLisIconBox d-flex align-items-center"
                            style={{ width: "160px", height: "40px", }}>
                            <select
                              className="border-0 search-input"
                              style={{
                                width: "210%",
                                height: "130%",
                                outline: "none",
                                background: "transparent",
                                cursor: "pointer",
                              }}
                              value={i?.userId}
                              onChange={(e) => handleSingleSelect(e.target.value, index)}
                            >
                              <option>Select Email</option>
                              {
                                nonMatchList?.usersNotCompleted?.map((list) => {

                                  return <option value={list?.userId}>{list?.email}</option>

                                })
                              }

                            </select>
                          </div>
                        </td>

                        {/* Quiz Name */}
                        <td style={{ textAlign: "left", minWidth: "160px" }}>
                          <div style={{ fontSize: 14, marginTop: '10px' }}>

                            <span style={{ color: "#009746" }}>{i?.name}</span>
                          </div>
                        </td>

                        {/* Email List */}
                        <td style={{ textAlign: "left", minWidth: "120px" }}>
                          <div style={{ fontSize: 14, marginTop: '10px' }}>


                            <span style={{ color: "#009746" }}>{i?.email}</span>
                          </div>
                        </td>


                        {/* Match Button */}
                        <td className="text-center">
                          <div className="d-flex justify-content-center ">
                            <CustomButton title="Update"
                              handleClick={() => updateSingleQuizScore(index)}
                            />
                          </div>
                        </td>
                      </tr>
                    })
                  }

                </tbody>
              </Table>

          }
          {/* <Table bordered hover responsive className="custom-table-border1">
            <thead>
              <tr>
                {currentSelected === "Perfect" ? <>
                  <th
                    style={{
                      fontWeight: "500",
                      textAlign: "left",  
                      minWidth: "140px",
                    }}
                    className="interRegular pb-0"
                  >
                    <h6>
                      {currentSelected === "Good" ? "" : " System Name"}{" "}
                    </h6>{" "}
                  </th>
                </> : <>

                </>}

                {currentSelected === "Perfect" ? <>
                  <th
                    style={{
                      fontWeight: "500",
                      textAlign: "left",
                      minWidth: "140px",
                    }}
                    className="interRegular pb-0"
                  >
                    <h6>{currentSelected === "Good" ? "" : "System email"} </h6>{" "}
                  </th>
                </> : <>

                </>}


                <th
                  style={{
                    fontWeight: "500",
                    textAlign: "left",
                    minWidth: "140px",
                  }}
                  className="interRegular pb-0"
                >
                  <h6>
                    {currentSelected === "Good" ? "Name" : "Quiz Name"}{" "}
                  </h6>{" "}
                </th>
                <th
                  style={{
                    fontWeight: "500",
                    textAlign: "left",
                    minWidth: "120px",
                  }}
                  className="interRegular pb-0"
                >
                  <h6>{currentSelected === "Good" ? "Email" : "Email List"}</h6>
                </th>
                {currentSelected === "Perfect" ? (
                  <></>
                ) : (
                  <>
                    {" "}
                    <th
                      style={{
                        fontWeight: "500",
                        textAlign: "left",
                        minWidth: "120px",
                      }}
                      className="interRegular pb-0"
                    >
                      <h6>Match %</h6>
                    </th>
                  </>
                )}
                <th style={{ fontWeight: "500" }} className="interRegular pb-0">
                  <h6>Match</h6>
                </th>
              </tr>
            </thead>
            <tbody>
              {mails?.map(
                (i, index) => {
                  return (
                    <tr>
                      {currentSelected === "Perfect" ? <>
                        <td style={{ textAlign: "left", minWidth: "140px" }}>
                          <div
                            style={{ fontSize: "14px" }}
                            className="interRegular"
                          >
                            <div
                              className="canLisIconBox ms-1 activeInAvtie d-flex align-items-center"
                              style={{ width: "160px", height: "40px", marginTop: "15px" }}
                            >
                              <select
                                className="border-0 search-input"
                                style={{
                                  width: "210%",
                                  height: "130%",
                                  outline: "none",
                                  background: "transparent",
                                  cursor: "pointer",
                                }}
                              >
                                <option value="">Search Name</option>
                                <option value="google">Google</option>
                                <option value="facebook">Facebook</option>
                                <option value="twitter">Twitter</option>
                              </select>
                      
                            </div>
                          </div>
                        </td>
                      </> : <></>}
                      {currentSelected === "Perfect" ? <>


                        <td style={{ textAlign: "left", minWidth: "40px" }}>
                          <div
                            style={{ fontSize: "14px" }}
                            className=""
                          >
                            <div
                              className="canLisIconBox ms-1 activeInAvtie d-flex align-items-center"
                              style={{ width: "160px", height: "40px", marginTop: "15px" }}
                            >
                              <input
                                type="text"
                                className="border-0 search-input"
                                style={{ width: "150%" }}
                                placeholder="Search Email List"
                              // value={search}
                              // onChange={(e) => {
                              //   setSearch(e.target.value);
                              //   filterDataByAll(e.target.value);
                              // }}
                              />
                    
                            </div>
                          </div>
                        </td>
                      </> : <></>}
                      <td style={{ textAlign: "left", minWidth: "140px" }}>
                        <div
                          style={{ fontSize: "14px" }}
                          className="interRegular"
                        >
                          {currentSelected === "Perfect" ? (
                            <>
                             
                            </>
                          ) : (
                            <>
                              {" "}
                              <span
                                style={{
                                  color: "#444ce7",
                                }}
                              >
                                {i?.name}
                              </span>
                            </>
                          )}

                          <br />

                          <span
                            style={{
                              color: "#009746",
                              // marginLeft: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            Swapan Kumar Debnath
                          </span>
                        </div>
                      </td>
                      <td style={{ textAlign: "left", minWidth: "120px" }}>
                        {" "}
                        <div
                          style={{ fontSize: "14px" }}
                          className="interRegular"
                        >
                          {currentSelected === "Perfect" ? (
                            <>
                             
                            </>
                          ) : (
                            <>
                              <span
                                style={{
                                  color: "#444ce7",
                                }}
                              >
                                {" "}
                                {i?.email}
                              </span>
                            </>
                          )}

                          <br />
                          <span
                            style={{
                              color: "#009746",
                            }}
                          >
                            sdebnath2k@rediffmail.com
                          </span>
                        </div>
                      </td>

                      {currentSelected === "Perfect" ? (
                        <></>
                      ) : (
                        <>
                          <td style={{ textAlign: "left", minWidth: "120px" }}>
                            <div className="interRegular">
                              {i?.excelMatches?.map((email) => {
                                return (
                                  <div style={{ fontSize: "14px" }}>{4.1}%</div>
                                );
                              })}
                            </div>
                          </td>{" "}
                        </>
                      )}
                      <td className="text-center">


                        {currentSelected === "Perfect" ? <> <div className="d-flex justify-content-center gap-1 mt-2">
                          <CustomButton
                            title="update"
                            // isLoading={isGenerating}
                            handleClick={() => { }}
                          />
                        </div></> : <>  {i?.excelMatches?.map((email) => {
                          return (
                            <input
                              type="checkbox"
                              onChange={(e) =>
                                updateIsMatch(
                                  i?.userId,
                                  email?.email,
                                  e.target.checked
                                )
                              }
                              checked={email?.isMatch}
                            />
                          );
                        })}</>}




                    
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </Table> */}
        </div>
      </Modal.Body>

      <Modal.Footer>
        {
          currentSelected === "Match" && <CustomButton
            title="Update Score"
            buttonType="primary"
            isLoading={isLoading}
            handleClick={updateQuizScore}
          />
        }

      </Modal.Footer>
    </Modal>
  );
}

export default DetailedPersonality;
